<template>
  <div class="network-alliance-page-new">
    <section class="our-advantages-section section-padding">
      <div class="container">
        <h2 class="section-title text-center">{{ $t('networkAlliancePage.ourAdvantages.title') }}</h2>
        <div class="advantages-grid-new">
          <div v-for="advantage in advantages" :key="advantage.id" class="advantage-item-new card-hover-light">
            <div class="advantage-icon-wrapper-new">
              <img :src="advantage.icon" :alt="$t(advantage.titleKey)" class="advantage-icon-new">
            </div>
            <h3 class="advantage-title-new">{{ $t(advantage.titleKey) }}</h3>
          </div>
        </div>
      </div>
    </section>

    <section class="platforms-support-section section-padding">
      <div class="container">
        <h2 class="section-title text-center">{{ $t('networkAlliancePage.weDeserveYou.title') }}</h2>
        <div class="platforms-support-grid">
          <div v-for="platformFeature in platformFeatures" :key="platformFeature.id" class="platform-feature-item">
            <div class="platform-feature-icon-wrapper">
              <img :src="platformFeature.icon" :alt="$t(platformFeature.textKey)" class="platform-feature-icon">
            </div>
            <div class="platform-feature-text">
              <p>{{ $t(platformFeature.textKey) }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="cooperation-cases-section-new section-padding">
      <div class="container">
        <h2 class="section-title text-center">{{ $t('networkAlliancePage.cooperationCases.title') }}</h2>
        <div class="cooperation-cases-grid-new">
          <div v-for="caseItem in cooperationCases" :key="caseItem.id" class="case-item-new card-hover-light">
            <img :src="caseItem.image" :alt="caseItem.alt || $t('networkAlliancePage.cooperationCases.altDefault')" class="case-image-new">
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import localizedTeamIcon from '@/assets/network-alliance/advantage-icon-localized.png';
import competitiveQuoteIcon from '@/assets/network-alliance/advantage-icon-platform.png';
import oneStopPlatformIcon from '@/assets/network-alliance/advantage-icon-quote.png';

import richChannelsIcon from '@/assets/network-alliance/deserve-img-apps.png';
import customizedStrategiesIcon from '@/assets/network-alliance/deserve-img-experience.png';
import manyYearsExperienceIcon from '@/assets/network-alliance/deserve-img-global.png';
import globalTrafficIcon from '@/assets/network-alliance/deserve-img-strategies.png';

import apeGirlsCaseImage from '@/assets/network-alliance/game1.png';
import thaiGameCaseImage from '@/assets/network-alliance/game2.png';
import datingAppCaseImage from '@/assets/network-alliance/game3.png';
import beautyAppCaseImage from '@/assets/network-alliance/game4.png';

export default {
  name: 'NetworkAlliancePageNew',
  data() {
    return {
      advantages: [
        { id: 'adv1', icon: localizedTeamIcon, titleKey: 'networkAlliancePage.ourAdvantages.items.localizedTeam' },
        { id: 'adv2', icon: competitiveQuoteIcon, titleKey: 'networkAlliancePage.ourAdvantages.items.competitiveQuote' },
        { id: 'adv3', icon: oneStopPlatformIcon, titleKey: 'networkAlliancePage.ourAdvantages.items.oneStopPlatform' }
      ],
      platformFeatures: [
        { id: 'pf1', icon: richChannelsIcon, textKey: 'networkAlliancePage.weDeserveYou.items.richChannels' },
        { id: 'pf2', icon: customizedStrategiesIcon, textKey: 'networkAlliancePage.weDeserveYou.items.customizedStrategies' },
        { id: 'pf3', icon: manyYearsExperienceIcon, textKey: 'networkAlliancePage.weDeserveYou.items.manyYearsExperience' },
        { id: 'pf4', icon: globalTrafficIcon, textKey: 'networkAlliancePage.weDeserveYou.items.globalTraffic' }
      ],
      cooperationCases: [
        { id: 'case1', image: apeGirlsCaseImage, alt: 'Ape Girls Game Case' },
        { id: 'case2', image: thaiGameCaseImage, alt: 'Thai Game Case' },
        { id: 'case3', image: datingAppCaseImage, alt: 'Dating App Case' },
        { id: 'case4', image: beautyAppCaseImage, alt: 'Beauty App Case' }
      ]
    };
  }
};
</script>

<style scoped>
.network-alliance-page-new {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  color: #1a202c;
  background-image: url('~@/assets/major-media-styled/bj.jpg');
  background-size: cover; 
  background-position: center; 
  background-repeat: no-repeat; 
}

.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-padding {
  padding: 70px 0;
}
@media (max-width: 768px) {
  .section-padding {
    padding: 50px 0;
  }
}

.text-center {
  text-align: center;
}

.section-title {
  font-family: "Acumin Variable Concept", "Inter", sans-serif;
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a2b48;
  margin-bottom: 50px;
}
@media (max-width: 768px) {
  .section-title {
    font-size: 2rem;
    margin-bottom: 40px;
  }
}

.card-hover-light {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-radius: 12px;
}
.card-hover-light:hover {
  transform: translateY(-6px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}

.our-advantages-section {
}
.advantages-grid-new {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
}
.advantage-item-new {
  background-color: #ffffff;
  padding: 30px 25px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}
.advantage-icon-wrapper-new {
  margin-bottom: 20px;
}
.advantage-icon-new {
  height: 150px;
  width: auto;
  max-width: 150px;
  object-fit: contain;
}
.advantage-title-new {
  font-size: 1.2rem;
  font-weight: 600;
  color: #334155;
}

.platforms-support-section {
}
.platforms-support-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 30px 40px;
}
.platform-feature-item {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  padding: 25px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}
.platform-feature-icon-wrapper {
  margin-right: 20px;
  flex-shrink: 0;
}
.platform-feature-icon {
  height: 70px;
  width: auto;
  max-width: 80px;
  object-fit: contain;
}
.platform-feature-text p {
  font-size: 1rem;
  color: #475569;
  line-height: 1.6;
  margin: 0;
}

.cooperation-cases-section-new {
}
.cooperation-cases-grid-new {
  display: grid;
  
  grid-template-columns: 1fr 1fr; 
  gap: 30px; 

}
.case-item-new {
  background-color: #e9effc;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.07);
}
.case-image-new {
  width: 100%;
  height: auto;
  aspect-ratio: 3 / 4;
  object-fit: cover;
  display: block;
}

@media (max-width: 992px) {
  .platforms-support-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 576px) {
  .advantages-grid-new,
  .cooperation-cases-grid-new {
    grid-template-columns: 1fr;
  }
  .platform-feature-item {
    flex-direction: column;
    text-align: center;
  }
  .platform-feature-icon-wrapper {
    margin-right: 0;
    margin-bottom: 15px;
  }
  .advantage-item-new {
    min-height: auto;
    padding: 25px;
  }
}
</style>